let abortController: AbortController | null = null;

export const getAbortController = (): AbortController => {
  if (abortController === null) {
    abortController = new AbortController();
  }

  return abortController;
};

export const refreshAbortController = (): void => {
  abortController = null;
};
